import { ResolverTag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import ResolverLink from '@swf/components/ResolverLink/ResolverLink';

import { DepositStatus } from '../../../../../../types/status';

import {
  TXTWCL_Deposits_might_take_some_time__ELL,
  TXTWCL_For_more_help_with_depositsX_v_ELL,
  TXTWCL_QR_codes_expire_after_15_minut_ELL,
  TXTWCL_To_find_out_moreX_visit_our_Xa_ELL,
  TXTWCL_Transactions_can_sometimes_tak_ELL
} from './HelpSectionContent.messages.json';

interface Props {
  isPayconiqTimeout?: boolean;
  status: DepositStatus;
}

const HelpSectionContent: React.FC<Props> = ({ isPayconiqTimeout, status }) => (
  <>
    {isPayconiqTimeout ||
      (status === DepositStatus.COMPLETED && (
        <>
          {isPayconiqTimeout ? (
            <Translation {...TXTWCL_QR_codes_expire_after_15_minut_ELL} />
          ) : (
            <Translation {...TXTWCL_Deposits_might_take_some_time__ELL} />
          )}{' '}
          <Translation
            values={{
              a: (msg: React.ReactNode) => (
                <ResolverLink resolverTag={ResolverTag.HelpCenterDepositWithdrawal}>
                  {msg}
                </ResolverLink>
              )
            }}
            {...TXTWCL_For_more_help_with_depositsX_v_ELL}
          />
        </>
      ))}
    {status === DepositStatus.MISSING_TRANSACTION_ID && (
      <>
        <Translation {...TXTWCL_Transactions_can_sometimes_tak_ELL} />{' '}
        <Translation
          values={{
            a: (msg: React.ReactNode) => (
              <ResolverLink resolverTag={ResolverTag.HelpCenter}>{msg}</ResolverLink>
            )
          }}
          {...TXTWCL_To_find_out_moreX_visit_our_Xa_ELL}
        />
      </>
    )}
  </>
);

export default HelpSectionContent;
